"use client";

import React from "react";
import Image from "next/image";

const AllOn4VsAllOn6: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          All-on-4 vs. All-on-6 Dental Implants
        </h2>
        <div className="my-8 mx-auto max-w-3xl rounded-lg overflow-hidden shadow-lg">
          <Image
            src="/images/graphic-comparison-of-two-full-arch-dental-implant-prosthetics-with-four-and-six-implant-posts-beside-smile4me-logo.jpg"
            alt="graphic-comparison-of-two-full-arch-dental-implant-prosthetics-with-four-and-six-implant-posts-beside-smile4me-logo"
            width={1000}
            height={667}
            className="w-full h-auto block"
            sizes="(max-width: 768px) 100vw, 768px"
          />
        </div>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Both treatments replace an entire arch with fewer implants than
          traditional methods. All-on-6 provides greater stability and bone
          support thanks to two additional implants. For patients with more
          jawbone volume or higher bite pressure, All-on-6 is often the better
          fit.
        </p>

        <div className="overflow-x-auto pt-4">
          <table className="w-full border-collapse border border-gray-300 text-left text-gray-700 text-sm sm:text-base">
            <thead className="bg-gray-100">
              <tr>
                <th className="border border-gray-300 px-4 py-3 font-semibold">
                  Feature
                </th>
                <th className="border border-gray-300 px-4 py-3 font-semibold">
                  All-on-4
                </th>
                <th className="border border-gray-300 px-4 py-3 font-semibold">
                  All-on-6
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 px-4 py-3 font-semibold">
                  Number of Implants
                </td>
                <td className="border border-gray-300 px-4 py-3">4 per arch</td>
                <td className="border border-gray-300 px-4 py-3">6 per arch</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="border border-gray-300 px-4 py-3 font-semibold">
                  Bone Density Required
                </td>
                <td className="border border-gray-300 px-4 py-3">Moderate</td>
                <td className="border border-gray-300 px-4 py-3">
                  Moderate to higher
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-3 font-semibold">
                  Stability Level
                </td>
                <td className="border border-gray-300 px-4 py-3">Strong</td>
                <td className="border border-gray-300 px-4 py-3">Stronger</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="border border-gray-300 px-4 py-3 font-semibold">
                  Best For
                </td>
                <td className="border border-gray-300 px-4 py-3">
                  Some bone loss
                </td>
                <td className="border border-gray-300 px-4 py-3">
                  Good bone volume or higher bite pressure
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-3 font-semibold">
                  Long-Term Bone Support
                </td>
                <td className="border border-gray-300 px-4 py-3">Good</td>
                <td className="border border-gray-300 px-4 py-3">Enhanced</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default AllOn4VsAllOn6;
